import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  GetCountyById,
  GetCountyList,
  UpdateCounty,
} from "../../services/county.service";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { toUpperCaseName } from "../../utils/helpers";

function EditCounty(props) {
  const history = useHistory();
  const location = useLocation();
  const [disableButton, setDisableButton] = useState(false);
  const [countyName, setCountyName] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    const loadCounty = async () => {
      const id = props.match.params.id;
      const stateData = location.state?.data;

      if (stateData) {
        setCountyName(stateData.name || "");
        setValue("name", stateData.name || "");
        setValue("description", stateData.description || "");
        setValue(
          "is_active",
          stateData.is_active === false ? "false" : "true"
        );
      }

      try {
        const result = await GetCountyById(id);
        const county =
          result?.data?.data || result?.data || (result?.id ? result : null);

        if (county && (county.id || county.name)) {
          setCountyName(county.name || "");
          setValue("name", county.name || "");
          setValue("description", county.description || "");
          setValue("is_active", county.is_active === false ? "false" : "true");
          return;
        }
      } catch (error) {
        // Fall back to list lookup if get-by-id is unavailable
      }

      if (!stateData) {
        try {
          const listResult = await GetCountyList(null);
          const match = (listResult.list || []).find(
            (item) => String(item.id) === String(id)
          );
          if (match) {
            setCountyName(match.name || "");
            setValue("name", match.name || "");
            setValue("description", match.description || "");
            setValue("is_active", match.is_active === false ? "false" : "true");
          } else {
            toast.error("County not found");
            history.push("/manage-counties");
          }
        } catch (error) {
          if (error.response?.status == 401) {
            EmptyLocalStorage();
            history.push("/");
          } else {
            toast.error(
              error.response?.data?.message || "Failed to load county"
            );
          }
        }
      }
    };

    loadCounty();
  }, [props.match.params.id, location.state, setValue, history]);

  const onSubmit = async (formData) => {
    setDisableButton(true);
    try {
      const id = props.match.params.id;
      const result = await UpdateCounty(id, {
        name: toUpperCaseName(formData.name),
        description: formData.description.trim(),
        is_active: formData.is_active === "true",
      });

      if (result.success) {
        toast.success(result.message || "County updated successfully");
        history.push("/manage-counties");
      } else {
        setDisableButton(false);
        toast.error(result.message || "Failed to update county");
      }
    } catch (error) {
      setDisableButton(false);
      if (error.response?.status == 401) {
        EmptyLocalStorage();
        history.push("/");
      } else {
        toast.error(
          error.response?.data?.message || "Failed to update county"
        );
      }
    }
  };

  return (
    <div className="AddNewUser">
      <h3 className="page-heading">
        <span className="custom-color-maroon">Edit County -</span> {countyName}
      </h3>
      <hr />
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Form
            className="formAddUser"
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row>
              <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>County Name</Form.Label>
                  <Form.Control
                    placeholder="Enter County Name"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "County name is required",
                      },
                      minLength: {
                        value: 2,
                        message: "Minimum length is 2",
                      },
                      maxLength: {
                        value: 255,
                        message: "Maximum length is 255",
                      },
                    })}
                    type="text"
                  />
                  {errors.name && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.name.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

              <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    placeholder="Enter Description"
                    {...register("description", {
                      required: {
                        value: true,
                        message: "Description is required",
                      },
                      maxLength: {
                        value: 500,
                        message: "Maximum length is 500",
                      },
                    })}
                    type="text"
                  />
                  {errors.description && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.description.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

              <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="is_active">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    {...register("is_active", {
                      required: {
                        value: true,
                        message: "Status is required",
                      },
                    })}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </Form.Select>
                  {errors.is_active && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.is_active.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                <input
                  type={"submit"}
                  className={"btn btn-green-theme w-100 mt-3"}
                  disabled={disableButton}
                  value={"Update County"}
                />
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default EditCounty;
